var EventName;
(function (EventName) {
    EventName["CLICK"] = "recommendation_module.selected";
    EventName["SEEN"] = "recommendation_module.presented";
})(EventName || (EventName = {}));
var EventType;
(function (EventType) {
    EventType["SEEN"] = "Impression";
    EventType["CLICK"] = "Interaction";
})(EventType || (EventType = {}));
var COMPONENT = 'destination-typeahead-input';
var SCHEMA_NAME = 'allRecommendations';
var RECOMMENDATION_TITLE_DEFAULT = {
    ALTERNATE: 'People also searched',
    POPULAR: 'Popular destinations'
};
var RECOMMENDATION_CATEGORIES = ['POPULAR', 'ALTERNATE'];
var RecommendationEvent = /** @class */ (function () {
    function RecommendationEvent() {
    }
    RecommendationEvent.getRecommendationSeenMessage = function (response, elementName) {
        if (response && response.sr && response.sr.length > 0) {
            var recommendedSuggestions = response.sr.filter(function (sr) { return RECOMMENDATION_CATEGORIES.includes(sr.category); });
            if (recommendedSuggestions && recommendedSuggestions.length > 0) {
                var recommendationEvent = {
                    eventType: EventType.SEEN,
                    eventName: EventName.SEEN,
                    egRecommendationResponseId: this.getEgRecommendationResponseId(response.recId),
                    recommendationTitle: this.getRecommendationTitle(recommendedSuggestions[0].category),
                    component: COMPONENT,
                    componentElement: elementName,
                    recommendations: this.getRecommendations(recommendedSuggestions)
                };
                return {
                    schemaName: SCHEMA_NAME,
                    messageContent: recommendationEvent
                };
            }
        }
        return undefined;
    };
    RecommendationEvent.getRecommendationClickedMessage = function (selected, response, elementName) {
        var _a, _b;
        if (selected && RECOMMENDATION_CATEGORIES.includes(selected.category)) {
            var rank = selected.index;
            if (response && response.sr && response.sr.length > 0) {
                var recommendations = response.sr.filter(function (sr) { return sr.category === selected.category; });
                for (var i = 0; i < recommendations.length; i++) {
                    if (((_a = recommendations[i].essId) === null || _a === void 0 ? void 0 : _a.sourceId) === ((_b = selected.essId) === null || _b === void 0 ? void 0 : _b.sourceId)) {
                        rank = i;
                        break;
                    }
                }
            }
            var recommendationEvent = {
                eventType: EventType.CLICK,
                eventName: EventName.CLICK,
                egRecommendationResponseId: this.getEgRecommendationResponseId(),
                recommendationTitle: this.getRecommendationTitle(selected.category),
                component: COMPONENT,
                componentElement: elementName,
                recommendations: this.getSelectedRecommendations(selected, rank)
            };
            return {
                schemaName: SCHEMA_NAME,
                messageContent: recommendationEvent
            };
        }
        return undefined;
    };
    RecommendationEvent.getEgRecommendationResponseId = function (responseId) {
        if (responseId) {
            this.egRecommendationResponseId = responseId;
        }
        return this.egRecommendationResponseId;
    };
    RecommendationEvent.getRecommendationTitle = function (recommendationType) {
        if (!this.recommendationTitle) {
            this.recommendationTitle =
                RECOMMENDATION_TITLE_DEFAULT[recommendationType];
        }
        return this.recommendationTitle;
    };
    RecommendationEvent.getRecommendations = function (results) {
        var _this = this;
        var recommendations = [];
        var trueIndex = 0;
        if (results && results.length > 0) {
            results.forEach(function (resultItem) {
                recommendations.push(_this.getRecommendation(resultItem, trueIndex));
                // eslint-disable-next-line no-plusplus
                trueIndex++;
            });
            recommendations.push();
        }
        return recommendations;
    };
    RecommendationEvent.getSelectedRecommendations = function (result, rank) {
        var recommendations = [];
        if (result) {
            recommendations.push(this.getRecommendation(result, rank));
        }
        return recommendations;
    };
    RecommendationEvent.getRecommendation = function (resultItem, rank) {
        var _a;
        return {
            recommendationId: (_a = resultItem.essId) === null || _a === void 0 ? void 0 : _a.sourceId,
            rank: rank,
            presentationDetails: {
                name: resultItem.regionNames.primaryDisplayName
            }
        };
    };
    return RecommendationEvent;
}());

export { RecommendationEvent };
